// /Users/zachepilka/radiomonitor-frontend/src/pages/static/PrivacyPage.it.jsx
import React from 'react';

export default function PrivacyPageIt() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Informativa sulla privacy di Radiomonitor.net</h1>
      <p>
        La presente Informativa sulla privacy descrive quali dati raccoglie Radiomonitor.net, come vengono utilizzati
        e come proteggiamo le vostre informazioni. Utilizzando il nostro Servizio, accettate la presente Informativa.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Quali dati raccogliamo</h2>
      <p>Raccogliamo solo i dati necessari al funzionamento del Servizio:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>informazioni tecniche (indirizzo IP, tipo di dispositivo, browser, sistema operativo);</li>
        <li>dati statistici sulle connessioni degli ascoltatori alle radio online;</li>
        <li>dati di contatto forniti in fase di registrazione (ad es. email).</li>
      </ul>
      <p>
        Non raccogliamo dati personali sensibili (ad es. dati del passaporto o bancari), salvo nei casi in cui l’utente
        li fornisca volontariamente per il pagamento o per la comunicazione.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Come utilizziamo i dati</h2>
      <p>I dati sono utilizzati esclusivamente per:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>erogare servizi di analytics e monitoraggio on-air;</li>
        <li>migliorare il Servizio;</li>
        <li>assistenza tecnica agli utenti;</li>
        <li>informare su aggiornamenti e nuove funzionalità di Radiomonitor.net.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Comunicazione a terzi</h2>
      <p>Non vendiamo né trasferiamo i vostri dati a terze parti.</p>
      <p>Fanno eccezione i casi in cui la comunicazione sia richiesta dalla legge.</p>
      <p>
        Per l’elaborazione dei pagamenti possiamo utilizzare sistemi di pagamento terzi affidabili
        (che trattano i dati in autonomia rispetto a noi).
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Conservazione dei dati</h2>
      <p>Conserviamo i dati solo per il tempo necessario all’erogazione dei servizi.</p>
      <p>L’utente può richiedere la cancellazione dei propri dati; evaderemo la richiesta entro un termine ragionevole.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Protezione dei dati</h2>
      <p>
        Radiomonitor.net adotta misure tecniche e organizzative per proteggere i dati da accessi non autorizzati,
        alterazioni o distruzione.
      </p>
      <p>
        Non possiamo garantire una sicurezza al 100% su Internet, ma adottiamo tutte le misure ragionevoli per assicurarla.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Cookie</h2>
      <p>Potremmo utilizzare cookie per migliorare l’esperienza d’uso e raccogliere statistiche.</p>
      <p>È possibile disabilitare i cookie nel browser; ciò potrebbe influire sul corretto funzionamento del Servizio.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. I vostri diritti</h2>
      <p>L’utente ha il diritto di:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>ottenere informazioni sui propri dati conservati dal Servizio;</li>
        <li>richiederne la rettifica o la cancellazione;</li>
        <li>revocare il consenso al trattamento.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Modifiche all’Informativa</h2>
      <p>
        Potremmo aggiornare periodicamente la presente Informativa. La versione aggiornata è sempre disponibile
        sul sito di Radiomonitor.net.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contatti</h2>
      <p>
        Per domande sulla privacy, contattateci:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
